export const saveSearchQuery = (query) => {
  if (typeof window === "undefined") return;
  const { text } = query;

  // Safe to access localStorage on the client side
  let searches = JSON.parse(localStorage.getItem("recentSearches")) || [];
  if (!searches.some((item) => item.text === text)) {
    searches = [{ ...query }, ...searches.slice(0, 9)]; // Keep up to 10 searches
    localStorage.setItem("recentSearches", JSON.stringify(searches));
  }
};

export const getRecentSearches = () => {
  if (typeof window === "undefined") return [];

  // Safe to access localStorage on the client side
  return JSON.parse(localStorage.getItem("recentSearches")) || [];
};
